module.exports = function() {
  return new Worker(__webpack_public_path__ + "eb03a572fa3a07710958.worker.js");
};